// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3NrrX","footer":"ModalInfo_footer__2Q4HY"};